export default __webpack_public_path__ + "static/media/pokedex.311a1b8c.png";